/* globalmodule */
/* homemodule */
define( '../src/sublayouts/m13-footer/m13-footer',[ 'jquery', 'lib/utils', 'tooltipster'], function ( $, utils, tooltipster ) {

	'use strict';

	var Footer = function ( $component ) {

		this.$component = $component;

		return this;
	};

	Footer.prototype.init = function () {
		var _this = this;

		this.$anchor = this.$component.find( '[data-m13-back-to-top="true"]' );
		this.$anchor.on( 'click', $.proxy( this.toTop, this ) );

		this.$footerModel = this.$component.find('.m39-modal__container')
		this.$modalWrapper = this.$component.find('.mask-show')

		this.$totalHeight = $(window).height()
		this.$topMargin = this.$totalHeight / 10
		this.$footerModel.css({'margin-top': this.$topMargin,'margin-bottom': this.$topMargin});

		this.$component.find('.m13-footer--medialinks_item').each(function() {
			var text = $(this).find('a').text();

			$(this).tooltipster({
				content: text,
				maxWidth: 250,
					arrow: true
			});
		});
		
		this.$component.find('.m13-footer_linktrigger--mobile').off('click.m13').on('click.m13', function(event) {
			event.preventDefault();

			$(this).closest('.m13-footer--floating_item').toggleClass('active');

		});
	};

	Footer.prototype.toTop = function ( e ) {

		e.preventDefault();

		$( 'body' ).attr( 'tabindex', -1 );

		if ( utils.isWindowsPhone() ) {

			$( 'html, body' ).scrollTop( 0 );
		} else {

			$( 'html, body' ).animate( {

				scrollTop: 0
			}, 500, function () {

				$( '#page' ).focus();
			} );
		}
	};



	return Footer;

} );

